import { LOCALE_ID, NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { TitleStrategy } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { ToastModule } from 'primeng/toast';
import { Interceptor } from 'src/interceptor/Interceptor';
import { CountryService } from './demo/service/country.service';
import { CustomerService } from './demo/service/customer.service';
import { EventService } from './demo/service/event.service';
import { IconService } from './demo/service/icon.service';
import { NodeService } from './demo/service/node.service';
import { PhotoService } from './demo/service/photo.service';
import { ProductService } from './demo/service/product.service';
import { MenuService } from './layout/app.menu.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ProgressBarModule } from 'primeng/progressbar';
import { AvatarModule } from 'primeng/avatar';
import { TabViewModule } from 'primeng/tabview';
import { ToolbarModule } from 'primeng/toolbar';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PessoaFormComponent } from './web/CADASTRO/pessoa/pessoa-form/pessoa-form.component';
import { PessoaListComponent } from './web/CADASTRO/pessoa/pessoa-list/pessoa-list.component';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { MessageModule } from 'primeng/message';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { TextareaModule } from 'primeng/textarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { PaginatorModule } from 'primeng/paginator';
import { EstacaoComponent } from './web/CONTROLE/estacao/estacao.component';
import { VariavelComponent } from './web/CADASTRO/variavel/variavel.component';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ChartModule } from 'primeng/chart';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { TreeTableModule } from 'primeng/treetable';
import { DashboardComponent } from './web/dashboard/dashboard.component';
import { SensorComponent } from './web/CADASTRO/sensor/sensor.component';
import { TipoSensorComponent } from './web/CADASTRO/tipo-sensor/tipo-sensor.component';
import { TipoDescodificadorComponent } from './web/CADASTRO/tipo-descodificador/tipo-descodificador.component';
import { BkGmapComponent } from './web/bk-gmap/bk-gmap.component';
import { LightGoogleMapComponent } from './shared/light-google-map/light-google-map.component';
import { UsuarioComponent } from './web/ACESSOS/usuario/usuario.component';
import { CredenciaisApiComponent } from './web/ACESSOS/credencias-api/credenciais-api.component';
import { ResumoEventoComponent } from './web/resumo-evento/resumo-evento.component';
import { RelatorioResumoEventoComponent } from './web/resumo-evento/relatorio/relatorio-resumo-evento.component';
import { RelatorioEventosAnaliticoComponent } from './web/resumo-evento/relatorio-eventos-analitico/relatorio-eventos-analitico.component';
import { GrupoUsuarioComponent } from './web/ACESSOS/grupo-usuario/grupo-usuario.component';
import { MonitoramentoComponent } from './web/CONTROLE/monitoramento/monitoramento.component';
import { ColetorComponent } from './web/CONFIGURACAO/coletor/coletor.component';
import { IntegradorComponent } from './web/CONFIGURACAO/integrador/integrador.component';
import { PermissoesComponent } from './web/ACESSOS/permissoes/permissoes.component';
import { ModeloEmailComponent } from './web/CONFIGURACAO/modelo-email/modelo-email.component';
import { EditorModule } from 'primeng/editor';
import { ObservacaoComponent } from './web/CADASTRO/observacao/observacao.component';
import { GrupoEstacaoComponent } from './web/CONTROLE/grupo-estacao/grupo-estacao.component';
import { GrupoEstacaoFormularioComponent } from './web/CONTROLE/grupo-estacao-formulario/grupo-estacao-formulario.component';
import { EventoServicoComponent } from './web/CONFIGURACAO/evento-servico/evento-servico.component';
import { ListboxModule } from 'primeng/listbox';
import { LogExecucaoIntegracaoComponent } from './web/CONTROLE/log-execucao-integracao/log-execucao-integracao.component';
import { LogBackupComponent } from './web/CONTROLE/log-backup/log-backup.component';
import { DescodificadorComponent } from './web/CONFIGURACAO/descodificador/descodificador.component';
import { GrupoEmailComponent } from './web/ACESSOS/grupo-email/grupo-email.component';
import { FileUploadModule } from 'primeng/fileupload';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';
import { DocumentoRepositorioComponent } from './web/CADASTRO/DOCUMENTOS/documento-repositorio/documento-repositorio.component';
import { DocumentosComponent } from './web/CADASTRO/DOCUMENTOS/documentos/documentos.component';
import { DocumentoEstacaoComponent } from './web/CADASTRO/DOCUMENTOS/documento-estacao/documento-estacao.component';
import { DadosVariavelComponent } from './web/CADASTRO/dados-variavel/dados-variavel.component';
import { RetriveImportacaoComponent } from './web/CADASTRO/retrive-importacao/retrive-importacao.component';
import { RelatorioDesempenhoComponent } from './web/RELATORIOS/relatorio-desempenho/relatorio-desempenho.component';
import { CadastroEventoComponent } from './web/CADASTRO/cadastro-evento/cadastro-evento.component';
import { LogUsuarioComponent } from './web/CONTROLE/log-usuario/log-usuario.component';
import { LogExecucaoColetaComponent } from './web/CONTROLE/log-execucao-coleta/log-execucao-coleta.component';
import { DashboardOperacaoComponent } from './web/CONTROLE/dashboard-operacao/dashboard-operacao.component';
import { ResumoEventosComponent } from './web/CONTROLE/resumo-eventos/resumo-eventos.component';
import { EventosMonitoramentosDialogComponent } from './shared/eventos-monitoramentos-dialog/eventos-monitoramentos-dialog.component';
import { LeituraEstacaoDialogComponent } from './shared/leitura-estacao-dialog/leitura-estacao-dialog.component';
import { MitsatTitleStrategy } from './services/mitsat-title.strategy';

@NgModule({ declarations: [
        AppComponent,
        PessoaFormComponent,
        PessoaListComponent,
        EstacaoComponent,
        VariavelComponent,
        DashboardComponent,
        SensorComponent,
        TipoSensorComponent,
        TipoDescodificadorComponent,
        BkGmapComponent,
        LightGoogleMapComponent,
        UsuarioComponent,
        CredenciaisApiComponent,
        ResumoEventoComponent,
        RelatorioResumoEventoComponent,
        RelatorioEventosAnaliticoComponent,
        GrupoUsuarioComponent,
        GrupoEmailComponent,
        MonitoramentoComponent,
        ColetorComponent,
        IntegradorComponent,
        PermissoesComponent,
        ModeloEmailComponent,
        ObservacaoComponent,
        GrupoEstacaoComponent,
        GrupoEstacaoFormularioComponent,
        EventoServicoComponent,
        LogExecucaoIntegracaoComponent,
        LogBackupComponent,
        DescodificadorComponent,
        DocumentoRepositorioComponent,
        DocumentosComponent,
        DocumentoEstacaoComponent,
        DadosVariavelComponent,
        RetriveImportacaoComponent,
        RelatorioDesempenhoComponent,
        CadastroEventoComponent,
        LogUsuarioComponent,
        LogExecucaoColetaComponent,
        DashboardOperacaoComponent,
        ResumoEventosComponent,
        EventosMonitoramentosDialogComponent,
        LeituraEstacaoDialogComponent,
    ],
    bootstrap: [AppComponent], imports: [AppRoutingModule,
        AppLayoutModule,
        ToastModule,
        BrowserModule,
        FormsModule,
        BrowserAnimationsModule,
        AccordionModule,
        AutoCompleteModule,
        AvatarModule,
        ProgressSpinnerModule,
        TabViewModule,
        ToolbarModule,
        DialogModule,
        ConfirmDialogModule,
        BreadcrumbModule,
        TableModule,
        DropdownModule,
        SelectModule,
        ToggleSwitchModule,
        AutoCompleteModule,
        MultiSelectModule,
        ReactiveFormsModule,
        MessageModule,
        CardModule,
        InputTextModule,
        InputTextModule,
        InputMaskModule,
        TextareaModule,
        InputNumberModule,
        RadioButtonModule,
        CheckboxModule,
        PaginatorModule,
        DatePickerModule,
        FloatLabelModule,
        ChartModule,
        MultiSelectModule,
        TreeTableModule,
        AccordionModule,
        TabViewModule,
        EditorModule,
        ListboxModule,
        FileUploadModule,
        ButtonModule,
        RippleModule,
        TooltipModule,
        ProgressBarModule], providers: [
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    darkModeSelector: false
                }
            }
        }),
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: TitleStrategy, useClass: MitsatTitleStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
        CountryService,
        CustomerService,
        EventService,
        IconService,
        NodeService,
        PhotoService,
        ProductService,
        MenuService,
        MessageService,
        ConfirmationService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
